import { connect } from 'react-redux'
import ContextMenu from './context-menu'
import {
  removeInvitation,
  markAsSeen,
  markAsUnseen
} from '../../../../../../../stores/current-invitations/current-invitations.actions'
import { copyMyFile } from '../../../../../../../stores/my-files/my-files.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { getInvitation } from '../../../../../../../stores/current-invitations/current-invitations.selectors'
import { withRouter } from 'react-router-dom'

const mapStateToProps = (state, { id }) => {
  const invitation = getInvitation(state, id)
  return {
    id: invitation.id,
    seen: invitation.seen,
    assessmentFileId: invitation.assessment_file.id,
    canMarkAsBenchmark: invitation.assessment_file.policy.can_mark_as_benchmark
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onRemove: () =>
    dispatch(removeInvitation(ownProps.id, stateProps.seen)).catch(
      errorHandler
    ),
  onCopy: () =>
    dispatch(copyMyFile(stateProps.assessmentFileId))
      .then(() => (window.location = `/moderation/my-files/`))
      .catch(errorHandler),
  onMarkAsSeen: () => dispatch(markAsSeen(ownProps.id)).catch(errorHandler),
  onMarkAsUnseen: () => dispatch(markAsUnseen(ownProps.id)).catch(errorHandler)
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  )(ContextMenu)
)
